declare namespace $ {

	type $mol_link__hint_shm_showcase_component_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['hint'] >
	>
	type $mol_link__arg_shm_showcase_component_2 = $mol_type_enforce<
		({ 
			'component': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_shm_showcase_component_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_text_code_demo__source_shm_showcase_component_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text_code_demo['source'] >
	>
	export class $shm_showcase_component extends $mol_page {
		component_title( ): string
		Close_icon( ): $mol_icon_close
		Close( ): $mol_link
		demo_content( ): readonly($mol_view)[]
		entry_id( ): string
		Code_demo( ): $mol_text_code_demo
		title( ): ReturnType< $shm_showcase_component['component_title'] >
		tools( ): readonly(any)[]
		body( ): ReturnType< $shm_showcase_component['demo_content'] >
	}
	
}

//# sourceMappingURL=component.view.tree.d.ts.map